// src/services/email/EmailTemplateService.ts

import { EmailTemplate } from './types';
import { unifiedEmailTemplate } from './templates/unifiedEmail';

export class EmailTemplateService {
  private templates: Map<string, EmailTemplate> = new Map();

  constructor() {
    // Register existing templates
    this.registerTemplate(unifiedEmailTemplate);
    
    
    // Alias für Rückwärtskompatibilität
    this.registerTemplateAlias('monthly-report', 'unified-email');
  }

  registerTemplate(template: EmailTemplate): void {
    this.templates.set(template.id, template);
  }

  registerTemplateAlias(alias: string, templateId: string): void {
    const template = this.templates.get(templateId);
    if (template) {
      this.templates.set(alias, template);
    }
  }

  getTemplate(templateId: string): EmailTemplate | undefined {
    return this.templates.get(templateId);
  }

  getAvailableTemplates(): Array<{ id: string; name: string }> {
    const uniqueTemplates = new Map<string, string>();
    
    this.templates.forEach((template, id) => {
      // Filtere Aliase aus
      if (id === template.id) {
        uniqueTemplates.set(id, template.name);
      }
    });

    return Array.from(uniqueTemplates.entries()).map(([id, name]) => ({ id, name }));
  }
}

export const emailTemplateService = new EmailTemplateService();
